import React from 'react';
import { twMerge } from 'tailwind-merge';

import { ControlsForward } from '@videoblocks/react-icons';

export interface AudioPlayerForwardButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    className?: string;
}

export const AudioPlayerForwardButton = ({ className, ...rest }: AudioPlayerForwardButtonProps): JSX.Element => {
    return (
        <button aria-label="audio player forward button" title="audio player forward button" {...rest}>
            <ControlsForward className={twMerge('w-6 h-6 fill-current hover:cursor-pointer', className)} />
        </button>
    );
};
